import { render } from "./SalesPersonCreationDialog.vue?vue&type=template&id=04ac43f9"
import script from "./SalesPersonCreationDialog.vue?vue&type=script&lang=js"
export * from "./SalesPersonCreationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__